import type { WidgetProps } from '@rjsf/utils'
import { Mtds } from 'prove-common'

export const CheckboxWidget = ({
  disabled,
  id,
  label,
  onChange,
  required,
  value,
  role,
  options
}: WidgetProps) => {
  const uiOptions = (options || {}) as { role?: string }
  const resolvedRole = role ?? uiOptions.role
  return (
    <Mtds.Field
      as='input'
      type='checkbox'
      role={resolvedRole}
      label={label}
      id={id}
      checked={value === true}
      onChange={({ target }) => onChange(target.checked)}
      disabled={disabled}
      required={required}
    />
  )
}
